export default "__VITE_ASSET__DChQllIx__"